export const reservasPanels = {
  // OtaMessages.vue
  ota: {
    appTitle: "Activa los mensajes OTA",
    installIntro:
      "Para responder a tus huéspedes de Booking.com / Airbnb desde WA Checkin necesitas instalar la aplicación",
    installIntroTail: "en el alojamiento.",
    installBtn: "Instalar mensajeria OTA",
    installing: "Instalando módulo de mensajes…",
    retryLink: "Ya he instalado la app, volver a comprobar",
    loading: "Cargando mensajes OTA…",
    empty: "No hay mensajes OTA para esta reserva.",
    modeAi: "IA",
    modeManual: "Manual",
    predefinedHeader: "Respuestas frecuentes",
    predefinedEmpty: "No hay respuestas que coincidan.",
    inputPlaceholder: "Escribe un mensaje o usa / para respuestas frecuentes...",
    attachTitle: "Adjuntar imagen",
    senderGuest: "Huésped",
    senderProperty: "Alojamiento",
    senderSystem: "Sistema",
    senderUnknown: "Desconocido",
    fileFallback: "archivo",
    toastTitle: "Mensajes OTA",
    errorTitle: "Error",
    loadError: "No se pudieron cargar los mensajes OTA.",
    modeErrorDetail:
      "No se pudo identificar el chat OTA. Intenta recargar la página.",
    modeManualOnTitle: "Modo Manual Activado",
    modeAiOnTitle: "Agente IA Activado",
    modeManualOnDetail: "Tú responderás los mensajes manualmente",
    modeAiOnDetail: "El bot responderá automáticamente",
    modeChangeError: "No se pudo cambiar el modo del chat OTA",
    sendError: "No se pudo enviar el mensaje OTA.",
    onlyImagesTitle: "Solo imágenes",
    onlyImagesDetail: "Por la OTA solo se pueden enviar imágenes.",
    imageTooBigTitle: "Imagen muy grande",
    imageTooBigDetail: "La imagen no puede superar los 5 MB.",
    installNoProperty: "No se ha encontrado la propiedad conectada a Channex.",
    installOk: "Aplicación instalada correctamente.",
    installError: "No se pudo instalar la aplicación.",
  },

  // ReservationNotes.vue
  notes: {
    composerPlaceholder: "Escribe una nota interna…",
    saveHint: "⌘ / Ctrl + Enter para guardar",
    saving: "Guardando…",
    addNote: "Añadir nota",
    loading: "Cargando notas…",
    emptyTitle: "Sin notas todavía",
    emptyText: "Añade la primera nota interna desde el cuadro de arriba.",
    cancel: "Cancelar",
    save: "Guardar",
    team: "Equipo",
    confirmDelete: "¿Eliminar?",
    yes: "Sí",
    no: "No",
    editTitle: "Editar",
    deleteTitle: "Eliminar",
    loadError: "No se pudieron cargar las notas",
    added: "Nota añadida",
    saveError: "No se pudo guardar la nota",
    updated: "Nota actualizada",
    updateError: "No se pudo actualizar la nota",
    deleted: "Nota eliminada",
    deleteError: "No se pudo eliminar la nota",
  },

  // ReservationPaymentsPanel.vue
  payments: {
    pendingLabel: "Pendiente",
    paidLabel: "Cobrado",
    totalLabel: "Total",
    loading: "Cargando pagos…",
    empty: "Aún no se ha registrado ningún pago.",
    addPayment: "Agregar pago…",
    fullyPaid: "Reserva cobrada por completo",
    recalcTitle: "Recalcular",
    sendWhatsappTitle: "Enviar por WhatsApp",
    copyLinkTitle: "Copiar link",
    editAction: "Editar",
    deleteAction: "Eliminar",
    modalEditTitle: "Editar pago",
    modalAddTitle: "Agregar pago",
    amountLabel: "Importe a cobrar",
    fillRemaining: "Cobrar el restante ({amount})",
    methodLabel: "Forma de pago",
    sendWhatsappCheck: "Enviar el link por WhatsApp al huésped",
    noteLabel: "Nota (opcional)",
    notePlaceholder: "Ej: señal, pago a la llegada…",
    cancel: "Cancelar",
    save: "Guardar",
    generateLink: "Generar link",
    registerPayment: "Registrar cobro",
    deleteConfirmTitle: "¿Eliminar este pago?",
    deleteText1: "Se eliminará el pago de",
    deleteLinkVoided: "El enlace de pago quedará anulado.",
    deleteIrreversible: "Esta acción no se puede deshacer.",
    deleteBtn: "Eliminar pago",
    sendConfirmTitle: "¿Enviar el link de pago?",
    sendText1: "Se enviará al huésped por WhatsApp el enlace para pagar",
    sendBtn: "Enviar link",
    methodCash: "Efectivo",
    methodCard: "Tarjeta/TPV Físico",
    methodTransfer: "Transferencia",
    methodOta: "Pagado por OTA",
    statusPaid: "Cobrado",
    statusPending: "Pendiente",
    statusFailed: "Fallido",
    statusCancelled: "Cancelado",
    loadError: "No se pudieron cargar los pagos.",
    amountRequired: "Indica un importe.",
    saveError: "No se pudo guardar el pago.",
    deleteError: "No se pudo eliminar.",
    sendLinkError: "No se pudo enviar el link.",
    recalcError: "No se pudo recalcular.",
  },

  // RoomAssignmentPanel.vue
  roomAssign: {
    title: "Asignar habitación",
    subWithUnitPre: "Esta reserva de",
    subWithUnitPost: "todavía no tiene una habitación física asignada.",
    subNoUnit: "Esta reserva todavía no tiene una habitación física asignada.",
    loading: "Buscando disponibilidad…",
    freePre: "Habitaciones libres para",
    freePost: "Elige una y asígnala directamente:",
    freeBadge: "Libre",
    assigning: "Asignando…",
    occupiedNote:
      "{count} habitación ocupada en estas fechas | {count} habitaciones ocupadas en estas fechas",
    noneFreeTitle: "No hay ninguna habitación libre para estas fechas.",
    noFreePre: "Todas las habitaciones de",
    thisType: "este tipo",
    noFreeMid:
      "están ocupadas o bloqueadas en {date}. Para poder asignar esta reserva,",
    reorganizeBold: "reorganiza las reservas",
    noFreeMid2: "de este tipo de habitación desde el calendario (botón",
    organizeBtn: "Organizar",
    noFreeTail: ") y así liberar una.",
    tagMaintenance: "Mantenimiento",
    tagBlocked: "Bloqueada",
    theseDates: "estas fechas",
    occupied: "Ocupada",
    assignedOk: "Habitación {label} asignada correctamente.",
    assignError: "No se pudo asignar la habitación.",
    notifyError: "Error",
    notifyDone: "Listo",
  },

  // GroupRoomsPanel.vue
  groupRooms: {
    heading: "Habitaciones de la reserva",
    typesCount: "{count} tipo | {count} tipos",
    roomsCount: "{count} habitación | {count} habitaciones",
    guestsCount: "{count} huésped | {count} huéspedes",
    totalLabel: "Total",
    viewingBadge: "Viendo",
    noRoomAssigned: "Sin habitación asignada",
    removeOneRoom: "Quitar una habitación",
    addOneRoom: "Añadir una habitación",
    confirmRemove: "¿Quitar?",
    yes: "Sí",
    no: "No",
    cannotRemoveOnly: "No puedes quitar la única habitación",
    removeRoomFromBooking: "Quitar esta habitación de la reserva",
    updating: "Actualizando…",
    theChannel: "el canal",
    otaManaged:
      "Esta habitación la gestiona {channel}: la cantidad y el precio se cambian allí.",
    notifyError: "Error",
    notifyDone: "Listo",
    qtyUpdated: "Cantidad actualizada",
    roomRemoved: "Habitación quitada de la reserva",
    updateError: "No se pudo actualizar la reserva. Intenta de nuevo.",
  },
};
